import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom'; // ← added this import

export function TeamSection({ leadershipHeader, teamMembers, cta }) {
  const { translate } = useLanguage();

  return (
    <section className="bg-bg-medium py-20 sm:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:justify-between gap-6 mb-16 sm:mb-20">
          <div className="max-w-2xl">
            <p className="text-[#3b82f6] text-[10px] sm:text-xs font-black tracking-[0.2em] uppercase mb-4">
              {leadershipHeader?.small_heading?.value || "LEADERSHIP"}
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-[42px] font-black text-white tracking-tight uppercase">
              {leadershipHeader?.main_title?.value || translate('newAbout.team.title')}
            </h2>
          </div>

          <div className="text-gray-500 text-start text-sm sm:text-base max-w-sm lg:text-right font-medium leading-relaxed">
            <div dangerouslySetInnerHTML={{ __html: leadershipHeader?.intro_text?.value || '' }} />
          </div>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-32">
          {teamMembers.map((member, idx) => (
            <div key={idx} className="group">
              <div className="relative aspect-[4/5] rounded-[24px] overflow-hidden mb-6 bg-[#13191f]">
                <img
                  src={member?.photo?.value || `/placeholder-team-${idx + 1}.jpg`}
                  alt={member?.name?.value || "Team member"}
                  className="w-full h-full object-cover grayscale transition-all duration-500 group-hover:grayscale-0 group-hover:scale-105"
                />
              </div>
              <h3 className="text-white font-bold text-lg sm:text-xl mb-1">
                {member?.name?.value || "Team Member"}
              </h3>
              <p className="text-[#3b82f6] text-[11px] sm:text-xs font-black tracking-wider uppercase">
                {member?.position?.value || "Position"}
              </p>
            </div>
          ))}
        </div>

        {/* CTA – using <Link> instead of <a> */}
        {cta && (
          <div className="relative rounded-[32px] bg-[#0d2137] overflow-hidden p-8 sm:p-12 lg:p-20 flex flex-col lg:flex-row items-center justify-between gap-10">
            <div className="absolute top-0 right-0 w-1/2 h-full bg-blue-500/10 blur-[120px] pointer-events-none" />

            <div className="relative z-10 max-w-xl text-center lg:text-left">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-6 leading-tight">
                {cta?.title?.value || translate('newAbout.team.ctaTitle')}
              </h2>
              <div className="text-gray-400 text-base sm:text-lg font-medium leading-relaxed">
                <div dangerouslySetInnerHTML={{ __html: cta?.description?.value || '' }} />
              </div>
            </div>

            <div className="relative z-10 flex flex-col sm:flex-row gap-4 w-full lg:w-auto">
              <Link
                to={cta?.primary_btn_link?.value || "#"}
                className="bg-[#1d63a3] hover:bg-blue-600 text-white px-8 py-4 rounded-xl font-bold text-sm transition-all shadow-lg shadow-blue-900/40 text-center"
              >
                {cta?.primary_btn_text?.value || translate('newAbout.team.getStarted')}
              </Link>

              <Link
                to={cta?.secondary_btn_link?.value || "#"}
                className="bg-[#1e2730] hover:bg-[#2a3541] text-white px-8 py-4 rounded-xl font-bold text-sm transition-all border border-white/5 text-center"
              >
                {cta?.secondary_btn_text?.value || translate('newAbout.team.contactSales')}
              </Link>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}